<template>
    <div class="w-full p-[16px]">
        <div class="bg-white p-6 rounded-lg text-[#2b2b2b]">
            <h2 class="text-[18px]">Détails revue</h2>
            <div v-if="loading" class="h-[100px] w-full flex items-center justify-center">
                <Loader2 class="animate-spin mx-auto"/>
            </div>
            <div v-else class="mt-7 font-light">
                <h3>Information collaborateur</h3>
                <div class="mt-4 flex flex-col gap-y-2">
                    <span><span class="underline">Matricule</span> : {{ data.user.matricule }}</span>
                    <span><span class="underline">Nom et prenom</span> : {{ data.user.first_name + " " + data.user.last_name }}</span>
                </div>
                <div class="mt-8">
                    <h3 class="text-[18px] underline">Information revue</h3>
                    <div class="mt-4 flex flex-col gap-y-2">
                        <span><span class="">Date de la revue</span> : {{ data.created_at }}</span>
                        <span><span class="">Note</span> : {{ data.mark ?? "Non défini" }}</span>
                        <span><span class="">Avis Responsable</span> : {{ data.sup_comment ?? "Non défini" }}</span>
                    </div>
                    <div class="mt-8">
                        <h3 class="text-[18px] underline">Commentaire collaborateur</h3>
                        <div class="mt-4 flex flex-col gap-y-2">
                            <span><span class="">Contributions</span> : {{ data.contributions ?? "Non défini" }}</span>
                            <span><span class="">Contributions externe</span> : {{ data.contributions_externe ?? "Non défini" }}</span>
                            <span><span class="">Apport externe</span> : {{ data.apport_externe ?? "Non défini" }}</span>
                            <span><span class="">Point d'amélioration</span> : {{ data.ameliorations ?? "Non défini" }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import API from '@/service/API';
import {
    Loader2
} from "lucide-vue-next";
export default{
    name:"DetailHRReview",
    components:{
        Loader2
    },
    data(){
        return {
            id:"",
            loading:true,
            data:{},
        }
    },
    created(){
        this.id = this.$route.params.id;
    },
    mounted(){
        this.getUpdateDetail(this.id);
    },
    methods:{
        getUpdateDetail(id){
            API.get('updates/' + id).then((response) => {
                if(response.data.status == 'success'){
                    this.data={...response.data["data"]};
                }
            }).catch((error) => {
                console.error(error);
            }).finally(() => {
                this.loading = false;
            });
        }
    }
}
</script>